import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue } from 'bootstrap-vue'
import VueRellax from 'vue-rellax'
import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);
Vue.use(BootstrapVue)
Vue.use(VueRellax)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


